import { Box } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'
import { BaseTable } from 'Features/Table/BaseTable.view'
import {
  InventoryStockPolicyRowType,
  InventoryStockPolicyTableProps,
} from './SystemOfRecords.types'

export const InventoryStockPolicyTable = ({
  data,
  isLoading,
  updateTableData,
  businessDrivenStockPolicy,
  locationCode,
  skuCode,
  unitOfMeasureCode,
  isUploading,
  uploadInventoryStockPolicy,
  isSaving = false,
}: InventoryStockPolicyTableProps & { isSaving?: boolean }) => {
  const columns: GridColDef[] = useMemo(
    () => [
      {
        headerName: 'ISO week',
        field: 'ISOWeek',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'ISO year',
        field: 'ISOYear',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Location code',
        field: 'LocationCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Max safety stock',
        field: 'MaxSafetyStock',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Min safety stock',
        field: 'MinSafetyStock',
        type: 'number',
        flex: 1,
        editable: true,
      },
      {
        headerName: 'SKU code',
        field: 'SKUCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Safety stock',
        field: 'SafetyStock',
        type: 'number',
        editable: true,
        flex: 1,
      },
      {
        headerName: 'Business driven stock policy',
        field: 'BusinessDrivenStockPolicy',
        flex: 1,
        editable: true,
        type: 'singleSelect',
        valueOptions: businessDrivenStockPolicy,
      },
      {
        headerName: 'Unit of measure code',
        field: 'UnitOfMeasureCode',
        type: 'string',
        flex: 1,
      },
    ],
    [data, businessDrivenStockPolicy]
  )

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <BaseTable
        data={data}
        columns={columns}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadData={uploadInventoryStockPolicy}
        isUploading={isUploading}
        isSaving={isSaving}
        checkBoxSelection={true}
        showTableToolBar={true}
        pinnedColumns={['ISOWeek', 'ISOYear', 'LocationCode']}
        downloadFileName="InventoryStockPolicy"
      />
    </Box>
  )
}
